module.exports = __webpack_public_path__ + "d927ea878c8c69dd9797e50a0f0ba840.svg";